export default function EmptyState({ icon, title, message, children, testId }) {
  return (
    <div className="z-empty" data-testid={testId}>
      {icon && <div className="z-empty-icon">{icon}</div>}
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {children && <div style={{ marginTop: 16 }}>{children}</div>}
    </div>
  );
}
